import { memo, type ReactNode, useState } from 'react'

import { Box, Group, Stack, Text } from '@mantine/core'

import { useGetFlags } from '@repo/common/hooks/flags'
import { useIsAuthenticated } from '@repo/common/queries/auth'

import logo_safari_video from '@/routes/_webpage/-support/fission.mov'
// eslint-disable-next-line @cspell/spellchecker
import logo_video from '@/routes/_webpage/-support/fission.webm'

import { FollowUs } from '../FollowUs'
import { Footer } from '../Footer'
import { LoginSignup } from '../LoginSignup'

import classes from './SiteAccess.module.css'

export const SiteAccess = memo<{
  children: ReactNode
  // eslint-disable-next-line complexity, max-lines-per-function
}>(function SiteAccess({ children }) {
  const is_authenticated = useIsAuthenticated()
  const { is_main_site } = useGetFlags()
  const [is_registered, set_is_registered] = useState(false)

  if (!is_main_site) {
    return children
  }

  if (!is_authenticated && !is_registered) {
    return (
      <Group justify="center">
        <Group maw="400px">
          <LoginSignup
            starting_mode="signup"
            header_as_link
            pre_register={set_is_registered}
          >
            <Stack gap="md">
              <Text size="xxl" lh="1.4" ta="center">
                VC Unlocked&nbsp;🔓.
              </Text>
              <Text size="lg" opacity={0.8}>
                Fission delivers access to venture capital investing onchain.
                We&apos;re launching our first Venture Capital Token soon.
              </Text>
              <Text size="lg" opacity={0.8} my="sm">
                Register to get first access when it launches.
              </Text>
            </Stack>
          </LoginSignup>
        </Group>
      </Group>
    )
  }

  return (
    <Stack mih="100vh" justify="space-between">
      <Stack maw="600px" align="center" mx="auto">
        <Box w={{ base: '320px', sm: '600px' }}>
          <video autoPlay muted loop width="100%" height="100%">
            <source src={logo_safari_video} type='video/mp4; codecs="hvc1"' />
            <source src={logo_video} type="video/webm" />
          </video>
        </Box>
        <Text size="lg">You&apos;re on the wait list.</Text>
        <Text>We&apos;ll let you know once Fission is live.</Text>
        <Stack className={classes.social} gap="md" align="center">
          <Group gap="xs">
            <Text size="sm">Follow Fission for the latest updates</Text>
            <FollowUs />
          </Group>
        </Stack>
      </Stack>
      <Box mx="xl3">
        <Footer />
      </Box>
    </Stack>
  )
})
